import { render, staticRenderFns } from "./TruckFlat.vue?vue&type=template&id=2750fce0"
import script from "./TruckFlat.vue?vue&type=script&lang=js"
export * from "./TruckFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports